import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import {
  ExchangeAntimalwareScanTask,
  ExchangeAntimalwareScanTaskTargetType,
} from '@nirvana/shared/dtos/types/policies/common';
import { sortByColumn } from './utils/sorters';

export interface ExchangeAntimalwareScanTaskFrontendFields extends ExchangeAntimalwareScanTask {
  targetType: ExchangeAntimalwareScanTaskTargetType;
}

export class GzExchangeAntimalwareScanTasksGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ExchangeAntimalwareScanTask
> {
  sortByColumnMethod(
    a: ExchangeAntimalwareScanTaskFrontendFields,
    b: ExchangeAntimalwareScanTaskFrontendFields,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    return;
  }

  protected getItemsWithAdditionalFrontendFields(
    items: ExchangeAntimalwareScanTask[]
  ): ExchangeAntimalwareScanTaskFrontendFields[] {
    return items.map(item => {
      return {
        ...item,
        targetType: item.target.targetType,
      };
    });
  }
}
